export const teamDirectory = {
  contacts: [
    { name: 'Mobile Team Lead', role: 'Senior Mobile Engineer', email: 'mobile-lead@company.com', slack: '@mobile-lead' },
    { name: 'iOS Architect', role: 'iOS Specialist', email: 'ios-arch@company.com', slack: '@ios-arch' },
    { name: 'Android Architect', role: 'Android Specialist', email: 'android-arch@company.com', slack: '@android-arch' },
    { name: 'Mobile Product Manager', role: 'Product', email: 'mobile-pm@company.com', slack: '@mobile-pm' }
  ],
  mentors: [
    { name: 'Senior Mobile Mentor', expertise: 'Cross-platform Development & Architecture', availability: 'Mon-Fri 2-4 PM' },
    { name: 'iOS Mentor', expertise: 'Swift, SwiftUI, iOS Frameworks', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Android Mentor', expertise: 'Kotlin, Jetpack Compose, Android Architecture', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Design Team', contact: 'design-lead@company.com', purpose: 'Mobile UI/UX Design' },
    { team: 'Backend Team', contact: 'backend-lead@company.com', purpose: 'Mobile API Integration' },
    { team: 'QA Team', contact: 'qa-lead@company.com', purpose: 'Mobile Testing Strategy' },
    { team: 'DevOps Team', contact: 'devops@company.com', purpose: 'Mobile CI/CD Pipeline' }
  ],
  channels: {
    primary: '#mobile-team',
    announcements: '#mobile-announcements',
    help: '#mobile-help',
    ios: '#ios-development',
    android: '#android-development',
    crossPlatform: '#cross-platform',
    releases: '#mobile-releases'
  }
};
